import { List, ListItem } from '../../../../components/List';
import { useEffect, useState } from 'react';

interface ILevelProfile {
  name: string;
  email: string;
  cpf: string;
  phoneNumber: string;
  photo?: string;
}

export function LevelProfile({
  name,
  email,
  cpf,
  phoneNumber,
  photo,
}: ILevelProfile) {
  const [percentage, setPercentage] = useState<number>(0);

  useEffect(() => {
    calculePercentage();
  }, [name, email, cpf, phoneNumber, photo]);

  const calculePercentage = () => {
    const namePercentage = name ? (name === '' ? 0 : 17.5) : 0;
    const emailPercentage = email ? (email === '' ? 0 : 17.5) : 0;
    const cpfPercentage = cpf ? (cpf === '' ? 0 : 17.5) : 0;
    const phonePercentage = phoneNumber ? (phoneNumber === '' ? 0 : 17.5) : 0;
    const photoPercentage = photo ? (photo === '' ? 0 : 30) : 0;

    const total =
      namePercentage +
      emailPercentage +
      cpfPercentage +
      phonePercentage +
      photoPercentage;

    setPercentage(total);
  };

  return (
    <>
      <p className="fw-semibold fs-5 m-0">Nível do perfil</p>
      <p className="mt-3">Completo</p>
      <div className="progress" role="progressbar">
        <div
          className="progress-bar bg-primary-color"
          style={{ width: `${percentage}%` }}
        >
          {percentage}%
        </div>
      </div>
      <List>
        <ListItem
          icon={photo ? (photo === '' ? 'close' : 'check') : 'close'}
          content="Imagem de Perfil"
        />
        <ListItem
          icon={name ? (name === '' ? 'close' : 'check') : 'close'}
          content="Nome / sobrenome"
        />
        <ListItem
          icon={email ? (email === '' ? 'close' : 'check') : 'close'}
          content="E-mail"
        />
        <ListItem
          icon={cpf ? (cpf === '' ? 'close' : 'check') : 'close'}
          content="CPF/CNPJ"
        />
        <ListItem
          icon={
            phoneNumber ? (phoneNumber === '' ? 'close' : 'check') : 'close'
          }
          content="Telefone"
        />
      </List>
    </>
  );
}
